module.exports = __webpack_public_path__ + "img/Classic.b9637ce9.jpg";